import script from "./DownloadAppStickyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadAppStickyHeader.vue?vue&type=script&setup=true&lang=js"

import "./DownloadAppStickyHeader.vue?vue&type=style&index=0&id=13058769&lang=scss"

const __exports__ = script;

export default __exports__